import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid, makeStyles } from '@material-ui/core';
import { CheckAnimate } from 'images/svg';
import { useTranslation, Trans } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.containerGrid,
    position: 'absolute',
    top: '50%',
    transform: ' translate(0, -50%)',
  },
  subTitleSuccessPaid: {
    ...theme.title,
    marginBottom: '1rem',
    fontSize: '30px',
  },
  subTitle: { ...theme.subTitle, margin: '0 3rem' },
  totalAmount: { whiteSpace: 'nowrap' },
}));
const PayConfirmationSuccess = ({ totalAmount }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Grid
      container
      className={classes.root}
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item>
        <CheckAnimate />
        <Typography align="center" className={classes.subTitleSuccessPaid}>
          {t('payment_success')}
        </Typography>
        <Typography align="center" className={classes.subTitle}>
          <Trans i18nKey="validated_payment_of" count={totalAmount}>
            Votre paiement de
            <strong title={t('nameTitle')} className={classes.totalAmount}>
              {{ totalAmount }}
            </strong>{' '}
            a bien été validé.
          </Trans>
        </Typography>
        <Typography align="center">{t('thank_you_for_your_visit')}</Typography>
      </Grid>
    </Grid>
  );
};

PayConfirmationSuccess.propTypes = {
  totalAmount: PropTypes.string.isRequired,
};

export default PayConfirmationSuccess;
